import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './pennsylvania-model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import {
  AdditionalOptions,
  PersonalInjuryProtectionSelection,
} from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-pennsylvania',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './pennsylvania.component.html',
  styleUrl: './pennsylvania.component.scss',
})
export class PennsylvaniaComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('pennsylvania', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('pennsylvania', null);
    }
  }

  optionsSelection = {
    accidentalDeathBenefits: '',
    totalLimit: '',
  };
  PersonalInjuryProtectionSelection = PersonalInjuryProtectionSelection;

  override eventHook(value: any): void {
    this.optionsSelection.accidentalDeathBenefits = '';
    this.optionsSelection.totalLimit = '';
    //On BasicFirstPartyBenefits selection Changes for ExtraordinaryMedicalBenefits_DropDown
    if (
      (this.baseRules &&
        this.baseRules['selectionId'] ===
          'IndividualStateCoverage_VaryByState_Null') ||
      this.baseRules['selectionId'] ===
        'IndividualStateCoverage_AcceptAdditionalPIP_Null'
    ) {
      if (value === 'BasicFirstPartyBenefits_LevelOne_Radio') {
        this.baseRules['ExtraordinaryMedicalBenefits_DropDown'] = 'hide';
      } else {
        this.baseRules['ExtraordinaryMedicalBenefits_DropDown'] = 'show';
      }
    }
  }

  override setupHookForDropDownData(): void {
    const pipOptionsDropdown = this.reactiveForm.get('OPTIONS_DropDown');
    if (pipOptionsDropdown?.value) {
      this.updateOptionsFromDropdown(pipOptionsDropdown?.value);
    }
  }

  onSelect($event, selectionId: string, formControlName: string): void {
    if (formControlName === 'OPTIONS_DropDown') {
      if (this.reactiveForm.get('OPTIONS_DropDown').valid) {
        this.optionsSelection = {
          accidentalDeathBenefits: $event.accidentalDeathBenefits,
          totalLimit: $event.totalLimit,
        };
      }
    }
    //Reset values on selection of Rejects Extraordinary Medical Benefits Coverage
    if (formControlName === 'ExtraordinaryMedicalBenefits_DropDown') {
      if ($event.id === 5) {
        if (this.baseRulesService?.pdfDataDump) {
          this.baseRulesService.pdfDataDump[
            'pennsylvania'
          ].extraordinarymedicalbenefits_1M = false;
          this.baseRulesService.pdfDataDump[
            'pennsylvania'
          ].extraordinarymedicalbenefits_100k = false;
          this.baseRulesService.pdfDataDump[
            'pennsylvania'
          ].extraordinarymedicalbenefits_300k = false;
          this.baseRulesService.pdfDataDump[
            'pennsylvania'
          ].extraordinarymedicalbenefits_500k = false;
        }
      }
    }
  }

  private updateOptionsFromDropdown(selectedValue: any): void {
    if (!this.controls || !this.controls[5] || !this.controls[5].data) {
      return;
    }

    // Get the option name (handle both string "Option 1" and object {name: "Option 1"} formats)
    const optionName =
      typeof selectedValue === 'string' ? selectedValue : selectedValue?.name;

    if (!optionName) return;

    // Find the matching option in controls[5].data
    const selectedOption: any = this.controls[5].data.find(
      (option: any) => option.name === optionName,
    );

    if (selectedOption) {
      // Update the local variable with values from the selected option
      this.optionsSelection = {
        accidentalDeathBenefits: selectedOption.accidentalDeathBenefits || '',
        totalLimit: selectedOption.totalLimit || '',
      };
    }
  }
  override dynamicRuleQueryBuilder(): string {
    if (
      !(
        this.baseRulesService.additionalOptions ===
        AdditionalOptions.RejectAdditionalPIP
      )
    ) {
      return 'ShowAllPart1';
    }
  }
}
